import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	invalidGroupName: {
		textDecoration: "line-through"
	}
})

export default useStyles
